import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="Radical Candor"
        desc="How to get what you want by saying what you mean"
        image="/images/books/radical-candor.png"
        pageType="book"
        author="Kim Scott"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/radical-candor.png"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                Radical Candor
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Kim Scott</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Kim Scott introduces a simple but powerful framework for being a great boss:
                care personally while challenging directly. Drawing from her experience at Google
                and Apple, she shows how the intersection of these two principles — Radical
                Candor — creates the kind of feedback culture where people do their best work.
                She also explores the pitfalls of obnoxious aggression, ruinous empathy, and
                manipulative insincerity, giving you a clear vocabulary for recognizing and
                correcting these patterns.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Whether you're a tech lead giving code reviews, a manager running one-on-ones,
                or an individual contributor learning to give better feedback, this book provides
                actionable guidance for building trust and driving results through honest
                communication. Join us as we discuss how to bring candor into our engineering teams.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
